import { useState } from 'react'
import {
  useEffect,
  Images,
  useNavigate,
  commonFunctions,
  Components,
} from '../utils/npm'
import ApplyButtons from './ApplyButtons'
import Labels from './Labels'
import { formatDate, formatIndianPrice } from './CommonFunction'
import { NotFound } from './NotFound'
// import { ,  } from '../utils/utils'
const { isIOS, isSafari, isIOSAndSafari, } = commonFunctions
const { selectIcon, IoCaretDownSharp, brokerzerodha, ipoDefault } = Images

const { extractLink } = commonFunctions

const IpoInnerList = ({ data, ipoCategory }) => {
  const navigate = useNavigate()
  const [isIos, setIsIos] = useState(false)

  useEffect(() => {
    if (isIOSAndSafari() || isIOS() || isSafari()) {
      setIsIos(true)
    } else {
    }
  }, [])

  return (
    <>
      <div className='ipoCardDetailsHome w-full'>
        {data.length > 0 && data?.map((ele, ind) => {
          return (
            <div className={`ipo-card `} key={ind}>
              <div className='ipo-card-inner'>
                <div className='ipo-card-header'>
                  <div className='card-header-top'>
                    <div className='logo-container'>
                      <img
                        src={
                          ele?.ipo_image !== null ? ele?.ipo_image : ipoDefault
                        }
                        onError={e => {
                          e.target.onerror = null
                          e.target.src = ipoDefault
                        }}
                        alt='Company Logo'
                        className='company-logo'
                        height={50}
                        width={50}
                      />
                      <h3
                        className={`company-name ${isIOS ? 'company-name_ios' : ''
                          }`}
                      >
                        {ele.company_name}
                      </h3>
                    </div>
                    <Labels data={ele} classList="badge-container  justify-end items-end flex-column" />
                  </div>
                </div>
                <div className='ipo-card-content'>
                  <div className='ipo-details'>
                    <div className='detail-item'>
                      <span className='label'>Offer Date</span>
                      <span className='value'>
                        {ele.start_date && ele.end_date ? formatDate(ele.start_date) + ' to ' + formatDate(ele.end_date) : '-'}
                        {/*
                        {ele.start_date?.split('-')?.reverse()?.join('-')} to{' '}
                        {ele.end_date?.split('-')?.reverse()?.join('-')}{' '} */}
                      </span>
                    </div>
                    <div className='detail-item'>
                      <span className='label'>Price Range</span>
                      <span className='value'>
                        ₹{ele.ipo_min_value} - ₹{ele.ipo_max_value}
                      </span>
                    </div>
                    <div className='detail-item'>
                      <span className='label'>Lot Size</span>
                      <span className='value'>{formatIndianPrice(ele?.bid_lot)} Shares</span>
                    </div>
                    {ipoCategory !== 'live' && (
                      <div className='detail-item'>
                        <span className='label'>Listed Price</span>
                        <span className='value highlight'>
                          {ele.listed_price === null ? '-' : ele.listed_price}
                        </span>
                      </div>
                    )}
                    <div className='detail-item'>
                      <span className='label'>Subscription</span>
                      <span className='value'>{ele.subscription} Times</span>
                    </div>
                    <div className='detail-item'>
                      <span className='label'>Expected Premium</span>
                      <span className='value highlight'>
                        {ele.gmp === null ? '-' : `₹${ele.gmp} (${ele?.ipo_max_value !== 0 && (((ele?.gmp / ele?.ipo_max_value) * 100))?.toFixed(2) + "%"})`}
                      </span>
                    </div>
                  </div>
                </div>
                <ApplyButtons data={ele} ipoCategory={ipoCategory} classList={"p-4 broker-actions"} type="" />
              </div>
            </div>
          )
        })}
        {data?.length === 0 && (
          <NotFound />
        )}
      </div>
    </>
  )
}

export default IpoInnerList
